<template>
	<div class="map-view" v-if="! sizeProblem">
		<div class="first">

			<div class="map-container" :ref="'mapContainer'">
				<Map class="business-map"
					:zoom="zoom"
					:clickableIcons="false"
					:streetViewControl="false"
					:myCoords="myC"
					:zoominfo="zoominfo"
					@updatedMarkers="updatedMarkers"
					:ref="'test'"
					@emitMarkers="emitMarkers"
				/>
				<div class="zoom-container">
					<button :disabled="! zoominfo.hasOwnProperty(zoom + 1)" @click="zoom++"> Zoom in {{ zoom }} </button>
					<button :disabled="! zoominfo.hasOwnProperty(zoom - 1)" @click="zoom--"> Zoom out {{ zoom }} </button>
				</div>
			</div>

		</div>

		<div class="other-container">
			<div class="other-row">
				<button class="poskytovatele butt" @click="getProviders"> Poskytovatele </button>
			</div>
			<div class="poskytovatele-row" v-if="(! loadingPoskytovatele) && providers.length > 0">
				<div v-for="(p, index) of providers" :key="index" class="poskytovatel">
					<div @click="active = p.spolecnost" :class="{ active: p.spolecnost === active }"> <span> {{ p.spolecnost }} ({{ p.count }}) </span> </div>
				</div>
			</div>
			<div v-else>
				<div v-if="loadingPoskytovatele">
					Nacitam poskytovatele
					<tile :loading="loading" :height="'1'" width="10"></tile>
				</div>
				<div v-else> Nacti poskytovatele </div>
			</div>
			<div class="other-row">
				<button :disabled="screenshotDisabled || (active === null) || sizeProblem" class="screenshot butt" @click="screenshot"> Screenshot </button>
			</div>
			<div v-if="sizeProblem">
				Problem s velikosti mapy.
				Velikost by mela byt v rozmerech ~1065x752.
				Momentalni velikost je {{ $refs.mapContainer.clientHeight }} x {{ $refs.mapContainer.clientWidth }}
			</div>
			<div v-if="gettingImage">
				<tile :loading="gettingImage" :height="'1'" width="10"></tile>
			</div>
		</div>

	</div>
	<div v-else>
		<div class="row mt-5">
			<div class="col">
				<h4> Problém s velikostí zařízení. </h4>
			</div>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
const html2canvas = require('html2canvas')

export default {
	name: 'UsersView',

	components: {
		Map: () => import('../components/MapTwo.vue'),
	},

	data() {
		return {
			test: 'test',
			zoom: 15,
			myC: {
				xCoord: '49.59284730689884',
				yCoord: '17.252538937929533'
			},
			markers: [],
			loading: false,
			zoominfo: {
				22: { lat: '0.00008082038', lng: '0.00017853453'},
				21: { lat: '0.00016207542', lng: '0.00035706907'},
				20: { lat: '0.00032588947', lng: '0.00071413815' },
				19: { lat: '0.00065004303', lng: '0.0014282763' },
				18: { lat: '0.00130357096', lng: '0.0028565526' },
				17: { lat: '0.00260717679', lng: '0.0057131052' },
				16: { lat: '0.00520058696', lng: '0.0114262104' },
				15: { lat: '0.01044623387', lng: '0.0228524208'},
				14: { lat: '0.02086131868', lng: '0.04570484161'},
				13: { lat: '0.04173156222', lng: '0.09140968322'},
				12: { lat: '0.08349882806', lng: '0.18281936645'},
				11: { lat: '0.16714050383', lng: '0.36563873291'},
				10: { lat: '0.33306071291', lng: '0.73127746582'},
				9: { lat: '0.67199396864', lng: '1.46255493164'},
				8: { lat: '1.35315778964', lng: '2.92510986328'},
			},
			loadingPoskytovatele: false,
			providers: [],
			screenshotDisabled: true,
			needPoskytovatele: true,
			active: null,
			sizeProblem: false,
			gettingImage: false,
		}
	},

	mounted () {
    console.log({ wsw: window.screen.width, wsh: window.screen.height, clh: this.$refs.mapContainer.clientHeight, clw: this.$refs.mapContainer.clientWidth })
		if (window.screen.width < 1500 || window.screen.height < 900) {
			this.sizeProblem = true
		}
		if (this.$refs.mapContainer.clientHeight < 750 || this.$refs.mapContainer.clientWidth < 1060) {
			this.sizeProblem = true
		}

		if (this.$refs.mapContainer.clientHeight > 760 || this.$refs.mapContainer.clientWidth > 1070) {
			this.sizeProblem = true
		}
	},

	methods: {
		updatedMarkers (newMarkers) {
			this.markers = newMarkers
			this.providers = []
			this.screenshotDisabled = true
			this.needPoskytovatele = true
			this.active = null
		},

		emitMarkers (markers) {
			this.markers = markers
		},

		zamerit () {
			this.zoom = 0
			this.$nextTick(() => {
				this.zoom = 15
			})
		},

		async screenshot () {
			const el = this.$refs['test'].$el

			const options = {
				useCORS: true,
			}
			const test = (await html2canvas(el, options)).toDataURL();

			this.gettingImage = true
			const data = await AdditionsService.sendImageWithCoords({ image: test, markers: this.markers, active: this.active })

			const a = document.createElement('a')
			a.href = 'data:image/png;base64,' + data.data.img
			a.download = data.data.name
			a.click()
			this.gettingImage = false
			var newTab = window.open()
			newTab.document.body.innerHTML = '<img src="' + a.href + '">'
		},

		async getProviders () {
			this.loadingPoskytovatele = true
			const providers = await AdditionsService.getProviders({ markers: this.markers })
			this.providers = providers.data.data
			this.loadingPoskytovatele = false
			this.screenshotDisabled = false
		}
	},

	watch: {
		zoom (to) {
			this.providers = []
			this.screenshotDisabled = true
			this.needPoskytovatele = true
		}
	}
}
</script>

<style scoped lang="stylus">
.map-view
	display flex
	flex-direction row
	padding-bottom 50px

.map-container
	min-height 756px
	min-width 1069px
	max-height 756px
	max-width 1069px
	border 2px solid black

.other-container
	display flex
	flex-direction column

.other-row
	display flex
	flex-direction row
	justify-content center

.first
	display flex
	flex-direction column

.butt
	width 220px

.poskytovatele-row
	display flex
	flex-direction column
	border 1px solid blue
	margin-top 20px
	margin-bottom 20px
	cursor pointer

.poskytovatel
	padding 5px
.active
	background-color rgba(59, 212, 255, 0.7)

</style>



// WEBPACK FOOTER //
// src/views/MapView.vue